<mat-card [class.wba]="environment.type !== 'web'">
  <strong *ngIf="environment.type == 'web'">Kundennummer als Barcode</strong>
  <a href="https://f9w44w6bf3.execute-api.eu-central-1.amazonaws.com/customer_card_generator/?id={{kundennummer}}">
    <button>
      <span *ngIf="environment.type == 'web'">Barcode erstellen</span>
      <span *ngIf="environment.type == 'mobil'">Kundennummer als Barcode</span>
    </button>
  </a>
</mat-card>
